module.exports = __webpack_public_path__ + "static/media/pre-dorset_preview.79a02c09.png";